<script>
export default {
  name: "userAgreement"
}
</script>

<template>
  <div class="agreement-container">
    <div class="agreement-content">
      <h2>易比图工具用户协议</h2>
      <p class="version-date"><strong>版本日期：2025年8月26日</strong></p>
      <p class="intro">本协议是您（以下简称"用户"）与易印公司（以下简称"本公司"）就使用易比图工具（以下简称"本软件"）服务所订立的协议。请您在注册、下载、安装或使用本软件及相关服务前，仔细阅读并充分理解本协议。</p>

      <h3>1. 服务内容</h3>
      <ul>
        <li>本软件提供屏幕截图图片比对与差异显示功能，主要用于包装印刷等视觉校对场景。</li>
        <li>本软件的比对结果仅供参考，最终决定应由用户自行或由专业人员确认。</li>
      </ul>

      <h3>2. 使用规范</h3>
      <ul>
        <li>用户不得将本软件用于任何违法、侵权或未经授权的用途。</li>
        <li>用户在使用本软件过程中产生的所有行为及后果，由用户自行承担。</li>
        <li>用户应自行做好数据备份和安全防护。</li>
      </ul>

      <h3>3. 知识产权</h3>
      <ul>
        <li>本软件及其全部内容，包括但不限于代码、界面设计、图标（含SVG图标）、文字、图像等，均受著作权法及相关法律保护，归本公司所有。</li>
        <li>未经本公司书面许可，用户不得复制、修改、出售、反向工程或以其他方式使用本软件的全部或部分内容。</li>
      </ul>

      <h3>4. 免责声明与责任限制</h3>
      <ul>
        <li>因用户依赖比对结果造成的任何直接或间接损失，本公司不承担责任。</li>
        <li>因不可抗力（包括但不限于自然灾害、网络故障、系统故障）导致的服务中断或数据丢失，本公司不承担责任。</li>
      </ul>

      <h3>5. 服务变更与终止</h3>
      <ul>
        <li>本公司保留随时修改、暂停或终止全部或部分服务的权利，并将在官网公告或通过适当方式提前通知用户。</li>
        <li>用户有权随时停止使用本软件。</li>
      </ul>

      <h3>6. 法律适用与争议解决</h3>
      <ul>
        <li>本协议的签订、履行、解释及争议解决均适用中华人民共和国法律。</li>
        <li>双方因本协议产生的争议，应友好协商解决；协商不成的，应提交至本公司所在地人民法院诉讼解决。</li>
      </ul>
    </div>
  </div>
</template>

<style scoped>
.agreement-container {
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
  color: #333;
  line-height: 1.6;
}

.agreement-content {
  background: white;
  padding: 30px;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
}

h2 {
  color: #2c3e50;
  text-align: center;
  margin-bottom: 15px;
  padding-bottom: 15px;
  border-bottom: 2px solid #eee;
  font-size: 28px;
}

.version-date {
  text-align: center;
  color: #7f8c8d;
  margin-bottom: 25px;
}

.intro {
  font-size: 16px;
  margin-bottom: 30px;
  color: #5a5a5a;
}

h3 {
  color: #34495e;
  margin: 25px 0 15px 0;
  padding-bottom: 8px;
  border-bottom: 1px solid #f0f0f0;
  font-size: 20px;
}

ul {
  padding-left: 20px;
  margin-bottom: 25px;
}

li {
  margin-bottom: 10px;
  color: #555;
  position: relative;
}



@media (max-width: 768px) {
  .agreement-container {
    padding: 15px;
  }

  .agreement-content {
    padding: 20px;
  }

  h2 {
    font-size: 24px;
  }

  h3 {
    font-size: 18px;
  }
}
</style>